import type * as layouts from '../ui'

import AdminLayout from '../ui/admin/admin.vue'
import AuthLayout from '../ui/auth/auth.vue'
import BaseNewLayout from '../ui/base-new/base-new.vue'
import BaseLayout from '../ui/base/base.vue'
import FullscreenLoadingLayout from '../ui/fullscreen-loading/fullscreen-loading.vue'
import PrivacyLayout from '../ui/privacy/privacy.vue'
import TestLayout from '../ui/test/test.vue'

export type LayoutType = keyof typeof layouts
export const DEFAULT_LAYOUT: LayoutType = 'base'

export const LAYOUTS_MAP: Record<LayoutType, Component> = {
  auth: AuthLayout,
  admin: AdminLayout,
  base: BaseLayout,
  baseNew: BaseNewLayout,
  fullscreenLoading: FullscreenLoadingLayout,
  privacy: PrivacyLayout,
  test: TestLayout,
}
